export default __webpack_public_path__ + "static/media/lifelink-app.72978d42.jpg";